import { Notifications } from '../Assessment.types';
import commentOnPage from '../../../assets/icons/onPageCommentIcon.svg';
import CommentIconHighContrast from '../../../assets/icons/onPageCommentIconSmallHighContrast.svg';
import { ReactComponent as MessageIcon } from '../../../assets/icons/message.svg';
import dIcon from '../../../assets/icons/d-icon.svg';
import dIconHighContrast from '../../../assets/icons/d-icon-high-contrast.svg';
import { ReactComponent as ControlTaskIcon } from '../../../assets/icons/control-task.svg';
import { IconButton } from '@material-ui/core';
import TooltipOne from '../../../components/TooltipOne/TooltipOne.component';
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import { fillBlue, fillRed } from '../../../utils/contrastSvgAttributes';
import { highContrastMode } from '../../../utils/highContrastChecker';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTabNavigationDetails } from '../../../Context/TabNavigation.context';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';

export const NotificationsTableItem: React.FC<Notifications> = (props) => {
  const { tabIndexForChildren } = useTabNavigationDetails();

  const style = {
    display: 'flex',
    flexDirection: 'row',
    tooltip: {
      backgroundColor: '#2C2D3E',
    },
    arrow: {
      color: '#2C2D3E',
    },
  } as React.CSSProperties;

  return (
    <div style={style} tabIndex={-1}>
      {props.isCommentOnImage && (
        <TooltipOne
          title="Komentarz na obrazie rozwiązania"
          placement="top"
          style={{
            display: 'inline-block',
            position: 'relative',
          }}
        >
          <IconButton disableRipple style={{ padding: '5px', cursor: 'default' }} tabIndex={tabIndexForChildren}>
            <img src={highContrastMode ? CommentIconHighContrast : commentOnPage} alt="ikona komentarza na stronie" />
          </IconButton>
        </TooltipOne>
      )}
      {props.isCommentOffPage && (
        <TooltipOne
          title="Komentarz poza stroną"
          placement="top"
          style={{
            display: 'inline-block',
            position: 'relative',
          }}
        >
          <IconButton disableRipple style={{ padding: '5px', cursor: 'default' }} tabIndex={tabIndexForChildren}>
            <div
              style={{
                width: '25px',
                height: '25px',
                borderRadius: '50%',
                backgroundColor: '#EA2075',
                textAlign: 'center',
              }}
            >
              <RateReviewOutlinedIcon style={{ color: 'white', width: '0.7em', height: '0.7em' }} />
            </div>
          </IconButton>
        </TooltipOne>
      )}
      {props.isCommentOnCriteria && (
        <TooltipOne
          title="Komentarz do kryterium"
          placement="top"
          style={{
            display: 'inline-block',
            position: 'relative',
          }}
        >
          <IconButton disableRipple style={{ padding: '5px', cursor: 'default' }} tabIndex={tabIndexForChildren}>
            <div
              style={{
                width: '25px',
                height: '25px',
                borderRadius: '50%',
                backgroundColor: '#3560FF',
                textAlign: 'center',
              }}
            >
              <SpeakerNotesIcon style={{ color: 'white', width: '0.7em', height: '0.7em' }} />
            </div>
          </IconButton>
        </TooltipOne>
      )}
      {props.emails && (
        <TooltipOne title="Wiadomość" placement="top">
          <IconButton disableRipple style={{ padding: '5px', cursor: 'default' }} tabIndex={tabIndexForChildren}>
            <MessageIcon fill={fillBlue} style={{ width: '1em', height: '0.7em', padding: '0.7px' }} />
          </IconButton>
        </TooltipOne>
      )}
      {props.warnings && (
        <TooltipOne
          title="Nierozstrzygnięty szczególny przypadek"
          placement="top"
          style={{
            display: 'inline-block',
            position: 'relative',
            padding: '5px',
          }}
        >
          <IconButton disableRipple style={{ padding: '5px', cursor: 'default' }} tabIndex={tabIndexForChildren}>
            <div>
              <ErrorOutlineIcon
                style={{ height: '28px', width: 'auto', marginBottom: '-5px', color: fillRed }}
              />
            </div>
          </IconButton>
        </TooltipOne>
      )}
      {props.closedSpecialCase && (
        <TooltipOne
          title="Zamknięty szczególny przypadek"
          placement="top"
          style={{
            display: 'inline-block',
            position: 'relative',
            padding: '5px',
          }}
        >
          <IconButton disableRipple style={{ padding: '5px', cursor: 'default' }} tabIndex={tabIndexForChildren}>
            <div>
              <ErrorOutlineIcon style={{ height: '28px', width: 'auto', marginBottom: '-5px', color: fillRed }} />
              <CheckCircleIcon
                style={{
                  position: 'absolute',
                  left: '21px',
                  top: '20px',
                  height: '16px',
                  width: 'auto',
                  color: 'green',
                }}
              />
            </div>
          </IconButton>
        </TooltipOne>
      )}
      {props.isControlProcessType && (
        <TooltipOne
          title="Zadanie kontrolne"
          placement="top"
          style={{
            display: 'inline-block',
            position: 'relative',
          }}
        >
          <IconButton disableRipple style={{ padding: '5px', cursor: 'default' }} tabIndex={tabIndexForChildren}>
            <ControlTaskIcon fill={fillBlue} />
          </IconButton>
        </TooltipOne>
      )}
      {props.isScoringAdjusted && (
        <TooltipOne
          title="Dostosowane zasady oceniania"
          placement="top"
          style={{
            display: 'inline-block',
            position: 'relative',
          }}
        >
          <IconButton disableRipple style={{ padding: '5px', cursor: 'default' }} tabIndex={tabIndexForChildren}>
            <img src={highContrastMode ? dIconHighContrast : dIcon} alt="ikona zmiany punktacji" />
          </IconButton>
        </TooltipOne>
      )}
      {props.changedScoreInfo && (
        <TooltipOne
          title={
            <>
              <p style={{ margin: '0px' }}>{`Ocena zmieniona przez ${props.changedScoreInfo?.supervisorRole}`}</p>
              <p
                style={{ margin: '0px' }}
              >{`Oryginalna ocena egzaminatora: ${props.changedScoreInfo?.previousScore}`}</p>
            </>
          }
          placement="top"
          style={{
            display: 'inline-block',
            position: 'relative',
          }}
        >
          <IconButton disableRipple style={{ padding: '5px', cursor: 'default' }} tabIndex={tabIndexForChildren}>
            <PublishedWithChangesIcon style={{ color: '#316394' }} />
            {/* <img src={highContrastMode ? dIconHighContrast : dIcon} alt="ikona zmiany punktacji" /> */}
          </IconButton>
        </TooltipOne>
      )}
    </div>
  );
};
